import { AnonymousUserChat } from '@medflex/shared-constants';
import getGenderFormatted from './getGenderFormatted.js';
import isSelf from './isSelf.js';
import isSupportPatient from './isSupportPatient.js';
import isDeletedStaff from './isDeletedStaff.js';

const contact = ({ firstName, gender = '', lastName, title = '' }, config) => {
  if (config && config.salutation) {
    return `${gender} ${title} ${firstName} ${lastName}`.trim();
  }
  return `${lastName}, ${firstName} ${title}`.trim();
};
const self = ({ firstName, lastName, title = '' }) => `${title} ${firstName} ${lastName}`.trim();
const support = () => 'medflex Kundenbetreuung';

/**
 * Retrieves the full name with title based on the provided parameters.
 *
 * @param {Object} params - The parameters object.
 * @param {string} [params.id] - The ID of the person.
 * @param {string} params.firstName - The first name of the person.
 * @param {string} params.lastName - The last name of the person.
 * @param {string} [params.gender] - The gender of the person.
 * @param {string} [params.title] - The title of the person.
 * @param {Object} [config] - The configuration object.
 * @returns {string} The full name with title.
 */
const get = ({ id = null, firstName, lastName, gender, title }, config) => {
  if (!firstName && !lastName) return 'Gelöschter Nutzer';
  if (isDeletedStaff(firstName)) return lastName;
  if (isSelf({ id })) return self({ firstName, lastName, title });
  if (isSupportPatient({ id })) return support();

  return contact(
    {
      firstName: firstName === AnonymousUserChat.firstName ? '-' : firstName || '-',
      lastName: lastName === AnonymousUserChat.lastName ? '-' : lastName || '-',
      gender: gender ? getGenderFormatted(gender) : '',
      title,
    },
    config,
  );
};

export default get;
export { contact, self, support, get };
